import type { SitePopup } from '@/lib/popups/types'

// Contract every popup template renders against. `onCtaClick` lets the
// controller apply the click cooldown and hide the popup — the --click
// analytics event itself fires via the anchor's data-track attributes.
// `reason` is the trigger that showed the popup ('delay', or an exit-intent
// reason); templates may vary copy on it (the CaptionCall modal does).
// `onDismiss` lets a template offer its own decline affordance ("Not now")
// that counts as a dismissal — cooldown + --dismiss event — exactly like the
// frame's close button; absent in the admin preview, where it's a no-op.
export interface PopupTemplateProps {
  popup: SitePopup
  /** Uppercase ISO country from ht_country; null when unavailable. */
  country: string | null
  onCtaClick: () => void
  onDismiss?: () => void
  reason?: string | null
}

// The non-trigger reasons: 'preview' (admin popup editor), 'force-show-flag'
// (?showPopup=), 'inline'/'inline-preview' (the popup_inline article blok,
// live vs draft/editor). Response-collecting templates must not record rows or
// fire analytics for any of them except a real 'inline' embed.
export const isLivePopupReason = (reason?: string | null): boolean =>
  reason !== 'preview' && reason !== 'force-show-flag' && reason !== 'inline-preview'

/** True when the template renders inside the article body (popup_inline blok) — no frame to close, so dismiss/close affordances should be hidden. */
export const isInlinePopupReason = (reason?: string | null): boolean =>
  reason === 'inline' || reason === 'inline-preview'
